export default __webpack_public_path__ + "media/images/fancybox/fancy_shadow_n-1fb2b7984faa4ae0baa091d829f4e898.png";